import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import { LibraryItem, LibraryItemType } from '@d-id/types';
import { ReactElement } from 'react';
import { DIDVideoTile } from './DIDVideoTile';
import { SimpleShowVideoTile } from './SimpleShowVideoTile';

export const VIDEO_TILE_WIDTH = 280;

interface Props {
    item: LibraryItem;
    origin: string;
}

const VideoTileRouter = ({ item, origin }: Props) => {
    if (item.type === LibraryItemType.SIMPLESHOW) {
        return <SimpleShowVideoTile item={item} origin={origin} />;
    }

    return <DIDVideoTile item={item} origin={origin} />;
};

const VideoTileWithErrorBoundary = (props: Props): ReactElement => (
    <ErrorBoundary
        fallback={<VideoTileRouter {...props} />}
        beforeCapture={scope => scope.setTags({ component: 'VideoTile', id: props.item.id, status: props.item.status })}>
        <VideoTileRouter {...props} />
    </ErrorBoundary>
);

export { VideoTileWithErrorBoundary as VideoTile };
